(function($) {
	$(function () {

        const $img = $('.js-img-appear-on-load');
        const $imgBox = $('.js-img-box-appear-on-load');

        $img
            .on('load', function() {
                heroPhotoLoadCallback($(this))
            })
            .each(function () {
                const $self = $(this)
                if ($self.width() > 0 && $self.height() > 0) {
                    heroPhotoLoadCallback($self)
                }
            })

        $imgBox.find('img')
            .on('load', function() {
                heroPhotoLoadCallback($(this).closest('.js-img-box-appear-on-load'))
            })
            .each(function () {
                const $self = $(this)
                if ($self.width() > 0 && $self.height() > 0) {
                    heroPhotoLoadCallback($self.closest('.js-img-box-appear-on-load'))
                }
            })

        function heroPhotoLoadCallback($photo) {      
            $photo.removeAttr('data-hidden')
        }

    })
})(jQuery);
